import moment from 'moment'

export const createParams = function createParams (params = {}) {
  let resultParams = {
    'select': setParam('select', 'select'),
    'filter': setParam('filter', 'filter'),
    'orderBy': setParam('orderBy', 'orderBy'),
    'expand': setParam('expand', 'expand'),
    'take': setParam('take', 'take'),
    'skip': setParam('skip', 'skip'),
    'count': setParam('count', 'count')
  }
  function setParam (fullName, shortName) {
    let value = params[fullName] || params[shortName]
    let falseValues = ['']
    if (falseValues.includes(value)) {
      value = undefined
    }
    return value
  }
  return JSON.parse(JSON.stringify(resultParams))
}

class MergeFilters {
  constructor (value) {
    this.value = value.filter(Boolean)
  }
  join (separator) {
    if (this.value.length === 0) {
      return undefined
    }
    return createStart(this.value.length, this.value.join(separator))
  }
}

const prepareValue = (value) => {
  return String(value).trim().replace(/"/gi, '\\"')
}
const createStart = (count, query) => {
  return count > 1 ? `(${query})` : query === '' ? undefined : query
}
export const makeFilter = (
  name,
  value,
  valueCreator
) => {
  const names = Array.isArray(name) ? name : [name]

  if (value === undefined) {
    return undefined
  }

  const values = names
    .map((_n) => valueCreator(String(_n), value))
    .filter(Boolean)

  return createStart(values.length, values.join('||'))
}

export const mergeFilters = (...filters) => {
  return new MergeFilters(filters)
}
export const select = (...args) => {
  return args.join(',').replace(/  +/g, ' ').replace(/\n/gm, '')
}

// Value creators
export const more = (name, value) => {
  if (!value) return undefined

  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}>${innerValue}`
}
export const less = (name, value) => {
  if (!value) return undefined

  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}<${innerValue}`
}

export const moreOrEquals = (name, value) => {
  if (!value || value === Infinity) return undefined

  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}>=${innerValue}`
}
export const lessOrEquals = (name, value) => {
  if (!value) return undefined

  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}<=${innerValue}`
}

export const dateMore = (name, value) => {
  const date = moment(value).format('YYYY,MM,DD,HH,mm,ss')
  return `${name} >= DateTime(${date})`
}
export const dateLess = (name, value) => {
  const date = moment(value).format('YYYY,MM,DD,HH,mm,ss')
  return `${name} <= DateTime(${date})`
}
export const dateDay = (name, value) => {
  const start = moment(value).startOf('day')
  const end = moment(value).endOf('day')

  return mergeFilters(
    dateMore(name, start),
    dateLess(name, end)
  ).join('&&')
}

export const equals = (name, value) => {
  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}==${innerValue}`
}
export const notEquals = (name, value) => {
  let innerValue = value

  if (typeof value === 'string') {
    innerValue = `"${prepareValue(value)}"`
  }
  return `${name}!=${innerValue}`
}
export const contains = (name, value) => {
  if (!value) return undefined

  return `${name}.contains("${prepareValue(String(value))}")`
}

// decorators
export const decoratorNotNullable = (creator) => {
  const result = (name, value) => {
    if ([value === null, value === ''].some(Boolean)) return undefined
    return creator(name, value)
  }
  return result
}
export const decoratorIsNumber = (creator) => {
  const result = (name, value) => {
    if ([!isFinite(value)].some(Boolean)) return undefined
    return creator(name, value)
  }
  return decoratorNotNullable(result)
}
export const decoratorCondition = (creator) => {
  return creator
  // TODO need to delete after tests
  // return (name, value) => {
  //   return `((${name} == null || ${name} == "") ? 1 == 1 : ${creator(name, value)})`
  // }
}
export const decoratorValueArray = (creator) => {
  return (name, value) => {
    if (!Array.isArray(value)) return undefined
    if (value.length === 0) return undefined
    return createStart(
      value.length,
      value.map((v) => makeFilter(name, v, creator)).join('||')
    )
  }
}
